import React, { JSX } from 'react'

interface Props{
    svgElement: JSX.Element
    onClick: () => void
    isActive: boolean
    isDisabled: boolean
    title: string
}

const PermissionButton:React.FC<Props> = ({ svgElement, onClick, isDisabled, title }) => {

    const useless = () => {
        return title.startsWith('Add') || title.startsWith('Delete');
    }
  
    return (
    <button disabled={isDisabled || useless()} onClick={onClick} >
        <span title={title}>
            {
                svgElement
            }
        </span>
    </button>
  )
}

export default PermissionButton